var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"uim-table"},[_c('tr',{staticClass:"uim-tr-head"},[_vm._t("uim-th")],2),_c('transition-group',{staticClass:"relative",attrs:{"name":"list-fade","tag":"tbody"}},[_vm._t("uim-tbd")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }